import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

import { CREATE_PIN_FAILURE, CREATE_PIN_REQUEST, CREATE_PIN_SUCCESS } from 'salon/constants';

const setPin = ({ salonId, stylistId }) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    authenticated: true,
    endpoint: `salon/v2/${salonId}/stylist/pin/`,
    config: {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ stylist: stylistId, salon: salonId }),
    },
    types: [CREATE_PIN_REQUEST, CREATE_PIN_SUCCESS, CREATE_PIN_FAILURE],
  },
});

// noinspection JSUnusedGlobalSymbols
export default setPin;
